import React from 'react';
import classnames from 'classnames';
import CloseBold from '@wix/da-ds/pkg/Icons/CloseBold';
import CloseSmall from '@wix/da-ds/pkg/Icons/CloseSmall';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import s from './CloseButton.scss';

export interface Props {
  view?: 'b5-1' | 'b5-2' | 'b5-3';
  href?: string;
  iconSize?: IconSize;
  className?: string;
  onClick?: (e?) => void;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  biData?: BiEvent;
  'aria-label'?: string;
}

export const CloseButton: React.FC<Props> = ({
  view = 'b5-1',
  href,
  onClick,
  iconSize,
  className,
  type,
  biData,
  'aria-label': ariaLabel,
}) => (
  <PlainButtonOrLink
    className={classnames(s['root'], s[view], className)}
    onClick={onClick}
    type={type}
    biData={biData}
    aria-label={ariaLabel}
    href={href}
  >
    {view === 'b5-2' ? (
      <CloseSmall className={s['icon']} size={iconSize} /> // I32A
    ) : (
      <CloseBold className={s['icon']} size={iconSize} /> // I32
    )}
  </PlainButtonOrLink>
);
CloseButton.displayName = 'CloseButton';

export default CloseButton;
